import { Dropdown } from 'antd';
import {
  useChatLayoutType,
  useSetChatLayoutType,
  useUpdateChatLayoutType,
} from 'hooks/useChatLayoutType';
import { PanelsTopLeft } from 'lucide-react';
import { useTranslate } from '@tolgee/react';
import { CheckOutlined } from '@ant-design/icons';
import { useReceptionConfig } from 'views/Setting/ConversationSetting/useReceptionConfig';
import { useEffect } from 'react';

export const ChatLayoutSelect = () => {
  const { t } = useTranslate();
  const chatLayoutType = useChatLayoutType();
  const setChatLayoutType = useSetChatLayoutType();
  const receptionConfig = useReceptionConfig();

  const { changeLayoutType } = useUpdateChatLayoutType();

  const items = [
    {
      label: t('app.config.conversationLayout.type.classic'),
      key: 'CLASSIC',
    },
    {
      label: t('app.config.conversationLayout.type.light'),
      key: 'LIGHT',
    },
  ];

  useEffect(() => {
    const layout = receptionConfig?.conversationPageLayout;
    setChatLayoutType(layout || 'CLASSIC');
  }, [setChatLayoutType, receptionConfig]);

  return (
    <Dropdown
      arrow
      placement="bottomRight"
      overlay={
        <div className="min-w-[120px] rounded shadow bg-[var(--fett-bg-elevated)]">
          <div
            className="px-3 h-[32px] leading-[32px] min-w-[120px] text-xs"
            style={{ color: 'var(--fett-text-tertiary)' }}
          >
            {t('app.config.conversationLayout.title')}
          </div>
          {items.map((item) => (
            <div
              key={item.key}
              className="px-3 h-[32px] leading-[32px] min-w-[120px] cursor-pointer flex items-center justify-between text-[var(--fett-text-secondary)] hover:bg-[var(--fett-bg-hover)]"
              onClick={() => changeLayoutType(item.key as General.ConversationPageLayout)}
            >
              <span>{item.label}</span>
              {chatLayoutType === item.key && (
                <CheckOutlined style={{ color: 'var(--fett-app-primary-color)' }} />
              )}
            </div>
          ))}
        </div>
      }
    >
      <PanelsTopLeft size={14} />
    </Dropdown>
  );
};
